"use client";

import React from "react";

import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { SecuredFooter } from "./ui/secured-footer";
import { cn } from "../lib/utils";
import payFailIcon from "../assets/icons/pay_fail_icon.svg";

/**
 * @param {object} props
 * @param {() => void} [props.onTryAgain]
 * @param {string | false} [props.border] Card border: `false` for none; custom Tailwind border classes; omit for default `border border-[#EBE9EF]`.
 * @param {string} [props.width] Width / max-width classes for the card (e.g. `w-full max-w-lg`). Defaults to `w-full`.
 * @param {boolean} [props.footer] When `false`, hides `SecuredFooter`. Defaults to `true`.
 */
const PaymentFailed = ({
  onTryAgain,
  border,
  width = "w-full",
  footer = true,
}) => {
  const handleTryAgain = () => {
    if (onTryAgain) {
      onTryAgain();
    }
  };

  const borderClass =
    border === false
      ? "border-0"
      : typeof border === "string"
        ? border
        : "border border-[#EBE9EF]";

  return (
    <Card
      className={cn(
        width,
        "relative rounded-2xl bg-white !shadow-none",
        borderClass
      )}
    >
      <CardContent className="w-full px-6 py-12">
        <div className="flex min-h-[400px] flex-col items-center justify-center text-center">
          {/* Fail Icon */}
          <div className="mb-8">
            <img
              src={payFailIcon}
              alt="Payment Failed"
              width={104}
              height={104}
            />
          </div>

          {/* Title */}
          <h1 className="mb-6 text-[32px] font-semibold leading-[40px] text-[#33125F]">
            Transaction failed
          </h1>

          {/* Subtitle */}
          <p className="max-w-[499px] text-[20px] leading-[32px] text-[#423E51]">
            Your payment was not successful. Please try again. If the problem
            persists, please contact support.
          </p>
        </div>
      </CardContent>

      {/* Try Again Button */}
      <div className="flex w-full justify-center px-6 pb-8">
        <Button
          onClick={handleTryAgain}
          className="h-[48px] w-[176px] rounded-full bg-[linear-gradient(70.19deg,#57249C_10.66%,#EB3366_113.47%)] px-16 py-3 text-[14px] font-semibold text-white hover:opacity-90"
        >
          Try Again
        </Button>
      </div>

      {footer ? <SecuredFooter /> : null}
    </Card>
  );
};

export default PaymentFailed;
